export const isNavigatingToSamePage = (nextUrl: string): boolean => {
  const currentPath = window.location.pathname;

  return nextUrl.startsWith(currentPath) && currentPath !== '/';
};
